import { render, staticRenderFns } from "./FigmaSpinnerLoader.vue?vue&type=template&id=81d51e6e"
import script from "./FigmaSpinnerLoader.vue?vue&type=script&lang=js"
export * from "./FigmaSpinnerLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports